import AuthService from 'src/services/api/auth.service';

import {
  AssignmentEnrollmentTypes,
  StudentAssignmentsQueryPayload,
  TeacherAssignmentsQueryPayload,
} from './types';

export const getStudentsAssignmentsQuery = ({
  domain,
  showContentStatuses,
  workType,
  includeSingleSessionCodes,
}: StudentAssignmentsQueryPayload) => {
  const userBk = AuthService.getUserBk();

  const includedEnrollmentTypes: AssignmentEnrollmentTypes[] = [
    'roster',
    'group',
    ...(includeSingleSessionCodes ? ['single_session' as const] : []),
  ];
  const requestBody = {
    includedEnrollmentTypes,
  };

  const domainQueryParam = domain ? `domain=${domain}` : '';
  const showContentStatusesQueryParam = showContentStatuses
    ? `showContentStatuses=${showContentStatuses}`
    : '';
  const workTypeQueryParam = workType ? `workType=${workType}` : '';

  const queryParamsList = [
    `showPastDueAssignments=${true}`,
    `showNotStartedAssignments=${false}`,
    `startOrCreatedDateSorting=${false}`,
    `archived=${false}`,
    domainQueryParam,
    showContentStatusesQueryParam,
    workTypeQueryParam,
  ];
  const queryParams = queryParamsList.filter(Boolean).join('&');

  return {
    url: `v2/user/${userBk}?${queryParams}`,
    method: 'POST',
    body: requestBody,
  };
};

export const getTeacherAssignmentsQuery = ({
  classBks,
  groupBks,
  domain,
  workType,
  includeSingleSessionCodes,
}: TeacherAssignmentsQueryPayload) => {
  const userBk = AuthService.getUserBk();

  const includeSingleSessionCodesForUser = includeSingleSessionCodes
    ? userBk
    : '';

  const requestBody = {
    classBks,
    groupBks,
    includeSingleSessionCodesForUser,
  };

  const domainQueryParam = domain ? `domain=${domain}` : '';
  const workTypeQueryParam = workType ? `workType=${workType}` : '';

  const queryParamsList = [
    `pendingOnly=${false}`,
    `archived=${false}`,
    domainQueryParam,
    workTypeQueryParam,
  ];
  const queryParams = queryParamsList.filter(Boolean).join('&');

  return {
    url: `v2/class/batch-get?${queryParams}`,
    method: 'POST',
    body: requestBody,
  };
};
